/**
 * Created by Tiger on 15/07/2022.
 */
import React, {useContext, useEffect, useLayoutEffect, useRef, useState} from 'react';
import zhData from '../../../components/country-code/data.json';
import enData from '../../../components/country-code/data_en.json';
import {connect} from 'react-redux';
import mapStateToProps from '../../../redux/util';
import styled from '@emotion/styled';
import {Input} from 'antd';
import {Column} from './lib';
import Back from './Back';
import {useHistory} from 'react-router-dom';
import useDebounce from "../../../hooks/useDebounce";
import i18n from "i18next";
import {ContextProps, MobileLoginContext} from "./index";
import {IndexBar, List} from "antd-mobile";
import {IndexBarRef} from "antd-mobile/es/components/index-bar";

interface Country {
  countryName: string;
  countryPinyin: string;
  phoneCode: string;
  countryCode: string;
}

interface GroupCountry {
  key: string;
  data: Country[];
}


const MobileCountryCode = () => {
  const {updatePhoneCode, phoneCode} = useContext(MobileLoginContext) as ContextProps;
  const [data, setData] = useState<GroupCountry[]>([]);
  const [inputContent, setInputContent] = useState('');
  const indexBarRef = useRef<IndexBarRef>(null)
  useLayoutEffect(() => {
    if (i18n.language.includes('zh')) {
      setData([...zhData]);
    } else {
      setData([...enData]);
    }
  }, []);
  useEffect(() => {
    let index = data.find((item) => item.data.find((item) => item.phoneCode === phoneCode))?.key || 'A'
    indexBarRef.current?.scrollTo(index)
  }, [data])
  const searchContent = useDebounce(inputContent)
  const history = useHistory();
  return (
    <div style={{display: 'flex', flexDirection: 'column'}}>
      <Column style={{
        marginLeft: 40,
        marginRight: 40,
        width: document.body.clientWidth - 80,
        backgroundColor: 'white',
        position: 'fixed',
        zIndex: 1,
      }}>
        <Back title={i18n.t('select_home')} onClick={() => {
          history.replace('/login/mobile')
        }}/>
        <MyInput
          placeholder={i18n.t('country_code_placeholder')} allowClear={true} value={inputContent}
          onChange={(event) => {setInputContent(event.target.value)}}/>
      </Column>
      <div style={{height: window.innerHeight - 130, marginTop: 130}}>
        <MyIndexBar ref={indexBarRef} sticky={true}>
          {
            data.map(({key, data}, index) => {
              const renderData = data.filter(({countryCode, countryName, countryPinyin, phoneCode}) => {
                return countryName.includes(searchContent) ||
                  ('+' + phoneCode).includes(searchContent) ||
                  countryPinyin.includes(searchContent) ||
                  countryCode.includes(searchContent)
              })

              return <>
                {
                  renderData.length > 0 && <IndexBar.Panel
                        style={{marginLeft: 40, marginRight: 40}}
                        index={key}
                        title={key}
                        key={key}
                    >
                        <List>
                          {
                            renderData.map(({countryName, phoneCode}, index) => (
                              <List.Item
                                key={`list-item-${key}-${index}`}
                                onClick={() => {
                                  updatePhoneCode(phoneCode)
                                  history.replace('/login/mobile')
                                }}
                              >
                                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                                  {countryName}
                                  <div>{`+${phoneCode}`}</div>
                                </div>
                              </List.Item>
                            ))
                          }
                        </List>
                    </IndexBar.Panel>
                }
              </>
            })
          }
        </MyIndexBar>
      </div>
    </div>
  );
};

const MyIndexBar = styled(IndexBar)`
  z-index: 0;
`

const MyInput = styled(Input)`
  -webkit-box-shadow: 0 0 0 1px #cccccc;
  border: none;
  //border-bottom: none;
  height: 40px;
  margin: 18px 0 10px;

  :focus {
    -webkit-box-shadow: 0 0 0 1px #007AFF;
  }
`;

export default connect(mapStateToProps, null)(MobileCountryCode);

